/**
 *
 */
const win: typeof window = import.meta.env.SSR ? (globalThis as never) : window;

if (import.meta.env.SSR) {
  const autoNamespace = /*           */ new Proxy(
    {},
    {
      get: /*                      */ () =>
        new Proxy({}, { get: /*                      */ () => {} }),
    },
  );

  /**
 *
 */
  win.o_global ||= autoNamespace as never;
  win.o_util ||= autoNamespace as never;
} else {
  /**
 *
 *
 *
 */
  /*                                                                 */
  win.o_global ||= {} as never;
  win.o_util ||= {} as never;
}

/*                   */
export { win };
export const { o_global, o_util } = win;
